module.exports = __webpack_public_path__ + "static/media/confirmation-icon.bdb3cb3f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/single-sample-modal/confirmation-icon.svg
// module id = 1761
// module chunks = 68